import { Route, Redirect, RouteProps, useLocation } from 'react-router-dom';

import auth from '../../utils/auth';
import { candidatePortalRoutes, connectRedirectUrls, connectUrlParams } from 'utils/constants/urls';
import { CONNECT_JOBBOARD_STATES } from 'utils/constants/connect';

const { PREFERENCES, PROFILE, QUALIFICATIONS } = connectRedirectUrls;
const { MATCH_DASHBOARD, CANDIDATE_PORTAL } = candidatePortalRoutes;

const PROTECTED_CONNECT_ROUTES = [PROFILE, QUALIFICATIONS, PREFERENCES];

const PROTECTED_CANDIDATE_ROUTES = [CANDIDATE_PORTAL, MATCH_DASHBOARD];

const AuthenticatedRoute: React.FC<RouteProps> = ({ children, ...rest }) => {
  const location = useLocation();

  return (
    <Route
      {...rest}
      render={() => {
        if (!auth.loggedIn()) {
          const isProtectedConnectRoute = PROTECTED_CONNECT_ROUTES.some((route) =>
            location.pathname.startsWith(route)
          );

          const isProtectedCandidateRoute = PROTECTED_CANDIDATE_ROUTES.some((route) =>
            location.pathname.startsWith(route)
          );

          let returnTo;
          let query = location.search;
          if (isProtectedConnectRoute) {
            returnTo = connectRedirectUrls.PROFILE;
          } else if (isProtectedCandidateRoute) {
            returnTo = location.pathname;
          } else {
            returnTo = `${location.pathname}${location.search}`;
            query = '';
          }

          const searchParams = new URLSearchParams(query);
          searchParams.set(connectUrlParams.RETURN_TO, returnTo);

          if (isProtectedConnectRoute && !searchParams.get(connectUrlParams.REDIRECT)) {
            searchParams.set(connectUrlParams.REDIRECT, CONNECT_JOBBOARD_STATES.MISSOURI.urlParam);
          }

          const search = searchParams.toString();

          let redirectPath;
          if (isProtectedConnectRoute) {
            redirectPath = connectRedirectUrls.SIGN_UP;
          } else if (isProtectedCandidateRoute) {
            redirectPath = connectRedirectUrls.LOGIN;
          } else {
            redirectPath = '/login';
          }

          return (
            <Redirect
              to={{
                pathname: redirectPath,
                search,
              }}
            />
          );
        }

        return <>{children}</>;
      }}
    />
  );
};

export default AuthenticatedRoute;
